import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

const ANIMAL_SELECTION_TAB_PATHS = new Set(['details', 'animals']);

/**
 * Houdt KSP tab-componenten (Gegevens/Dieren) in geheugen bij wisselen via router-outlet.
 * IonicRouteStrategy detached standaard niets; daardoor remountte elke tab-switch.
 */
@Injectable()
export class AnimalSelectionTabRouteReuseStrategy extends IonicRouteStrategy {
  private readonly _tabHandles = new Map<string, DetachedRouteHandle>();

  override shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const key = this._getTabStoreKey(route);
    return !!key || super.shouldDetach(route);
  }

  override store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    const key = this._getTabStoreKey(route);
    if (key && handle) {
      this._tabHandles.set(key, handle);
      return;
    }
    super.store(route, handle);
  }

  override shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this._getTabStoreKey(route);
    return (key && this._tabHandles.has(key)) || super.shouldAttach(route);
  }

  override retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this._getTabStoreKey(route);
    if (key && this._tabHandles.has(key)) {
      return this._tabHandles.get(key)!;
    }
    return super.retrieve(route);
  }

  private _getTabStoreKey(route: ActivatedRouteSnapshot): string | null {
    const path = route.routeConfig?.path;
    if (!path || !ANIMAL_SELECTION_TAB_PATHS.has(path)) {
      return null;
    }

    const selectionId = this._findSelectionId(route);
    if (!selectionId) {
      return null;
    }

    return `animal-selection:${selectionId}:${path}`;
  }

  private _findSelectionId(route: ActivatedRouteSnapshot): string | null {
    let current: ActivatedRouteSnapshot | null = route;
    while (current) {
      if (current.params['id']) {
        return String(current.params['id']);
      }
      current = current.parent;
    }
    return null;
  }
}
